export function panelLevelsRenderer(param: { value?: any }) {
  const value = parseInt(param.value);

  if (value >= 1 && value <= 5) {
    return "<span class='fa fa-square gridPanelLevel__indicator--L" + value + "'></span>";
  }

  return '';
}
